var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarContentBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 1.16848 0.131696 0.850537 0.366117 0.616116C0.600537 0.381696 0.918479 0.25 1.25 0.25H18.75C19.0815 0.25 19.3995 0.381696 19.6339 0.616116C19.8683 0.850537 20 1.16848 20 1.5V4C20 4.33152 19.8683 4.64946 19.6339 4.88388C19.3995 5.1183 19.0815 5.25 18.75 5.25V14.625C18.75 15.4538 18.4208 16.2487 17.8347 16.8347C17.2487 17.4208 16.4538 17.75 15.625 17.75H4.375C3.5462 17.75 2.75134 17.4208 2.16529 16.8347C1.57924 16.2487 1.25 15.4538 1.25 14.625V5.25C0.918479 5.25 0.600537 5.1183 0.366117 4.88388C0.131696 4.64946 0 4.33152 0 4V1.5ZM2.5 5.25V14.625C2.5 15.1223 2.69754 15.5992 3.04917 15.9508C3.40081 16.3025 3.87772 16.5 4.375 16.5H15.625C16.1223 16.5 16.5992 16.3025 16.9508 15.9508C17.3025 15.5992 17.5 15.1223 17.5 14.625V5.25H2.5ZM18.75 1.5H1.25V4H18.75V1.5ZM6.25 8.375C6.25 8.20924 6.31585 8.05027 6.43306 7.93306C6.55027 7.81585 6.70924 7.75 6.875 7.75H13.125C13.2908 7.75 13.4497 7.81585 13.5669 7.93306C13.6842 8.05027 13.75 8.20924 13.75 8.375C13.75 8.54076 13.6842 8.69973 13.5669 8.81694C13.4497 8.93415 13.2908 9 13.125 9H6.875C6.70924 9 6.55027 8.93415 6.43306 8.81694C6.31585 8.69973 6.25 8.54076 6.25 8.375Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarContentBlue);
export default __webpack_public_path__ + "static/media/sidebar-content-blue.fb9f3e18cd0fc18c53036e898e04769f.svg";
export { ForwardRef as ReactComponent };